import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import WebMercatorViewport from 'viewport-mercator-project';

var Viewport = /*#__PURE__*/function () {
  function Viewport() {
    _classCallCheck(this, Viewport);
  }

  _createClass(Viewport, [{
    key: "syncWithMapCamera",
    value: function syncWithMapCamera(mapCamera) {
      var center = mapCamera.center,
          zoom = mapCamera.zoom,
          pitch = mapCamera.pitch,
          bearing = mapCamera.bearing,
          viewportHeight = mapCamera.viewportHeight,
          viewportWidth = mapCamera.viewportWidth;
      var preView = this.viewport ? {
        width: this.viewport.width,
        height: this.viewport.height,
        longitude: this.viewport.center[0],
        latitude: this.viewport.center[1],
        zoom: this.viewport.zoom,
        pitch: this.viewport.pitch,
        bearing: this.viewport.bearing
      } : {};
      /**
       * Deck.gl 使用的也是 Mapbox 同步相机，相机参数保持一致
       * 例如相机高度固定为 height * 1.5，因此不需要传
       */

      this.viewport = new WebMercatorViewport(_objectSpread(_objectSpread({}, preView), {}, {
        width: viewportWidth,
        height: viewportHeight,
        longitude: center && center[0],
        latitude: center && center[1],
        zoom: zoom,
        pitch: pitch,
        bearing: bearing
      }));
    }
  }, {
    key: "getZoom",
    value: function getZoom() {
      return this.viewport.zoom;
    }
  }, {
    key: "getZoomScale",
    value: function getZoomScale() {
      return Math.pow(2, this.getZoom());
    }
  }, {
    key: "getCenter",
    value: function getCenter() {
      return [this.viewport.longitude, this.viewport.latitude];
    }
  }, {
    key: "getProjectionMatrix",
    value: function getProjectionMatrix() {
      return this.viewport.projectionMatrix;
    }
  }, {
    key: "getModelMatrix",
    value: function getModelMatrix() {
      return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
    }
  }, {
    key: "getViewMatrix",
    value: function getViewMatrix() {
      return this.viewport.viewMatrix;
    }
  }, {
    key: "getViewMatrixUncentered",
    value: function getViewMatrixUncentered() {
      // @ts-ignore
      return this.viewport.viewMatrixUncentered;
    }
  }, {
    key: "getViewProjectionMatrix",
    value: function getViewProjectionMatrix() {
      // @ts-ignore
      return this.viewport.viewProjectionMatrix;
    }
  }, {
    key: "getViewProjectionMatrixUncentered",
    value: function getViewProjectionMatrixUncentered() {
      // @ts-ignore
      return this.viewport.viewProjectionMatrix;
    }
  }, {
    key: "getFocalDistance",
    value: function getFocalDistance() {
      return 1;
    }
    /**
     * P20 坐标系，固定 scale
     */

  }, {
    key: "projectFlat",
    value: function projectFlat(lngLat, scale) {
      return this.viewport.projectFlat(lngLat, scale);
    }
  }]);

  return Viewport;
}();

export { Viewport as default };